import { StorageStateKeysEnum } from "@utils/storage";
import { action, observable } from "mobx";
import { DeviceDetector } from "@utils";
import { isCapacitorPlatform } from "@utils/specific/capacitor/helpers";
import type { RootStore } from "@state/stores/types";

export default class GamePauseStore {
	@observable gameOverlayFinishTime: number | null = null;

	rootStore: RootStore;

	constructor(rootStore: RootStore) {
		this.rootStore = rootStore;
	}

	@action.bound
	setGameOverlayFinishTime(value: number | null) {
		this.gameOverlayFinishTime = value;
	}

	@action.bound
	startGameOverlayTimer() {
		const expiresIn = 300000; //5 minutes in miliseconds

		const currentTime = new Date().getTime();
		const expireTime = currentTime + expiresIn;

		this.setGameOverlayFinishTime(expireTime);

		if (
			this.rootStore.sessionExpireStore.isGameOpen &&
			(DeviceDetector.isMobileTheme || isCapacitorPlatform())
		) {
			history.back();
		}
	}

	@action.bound
	syncTimerWithLocalStorage() {
		if (
			this.rootStore.localStorageProvider.get(
				StorageStateKeysEnum.GAME_OVERLAY_FINISH_TIME
			) != null
		) {
			this.setGameOverlayFinishTime(
				Number(
					this.rootStore.localStorageProvider.get(
						StorageStateKeysEnum.GAME_OVERLAY_FINISH_TIME
					)
				)
			);
		} else if (this.gameOverlayFinishTime) {
			this.rootStore.localStorageProvider.set(
				StorageStateKeysEnum.GAME_OVERLAY_FINISH_TIME,
				this.gameOverlayFinishTime
			);
		}
	}

	@action.bound
	disposeTimerData() {
		this.rootStore.localStorageProvider.remove(
			StorageStateKeysEnum.GAME_OVERLAY_FINISH_TIME
		);
		this.setGameOverlayFinishTime(null);
	}
}
